<template>
  <li :class="[ns.b(), { [ns.e('center')]: center }]">
    <div :class="[ns.e('tail'), ns.em('tail', size || '')]" />
    <div
      v-if="!$slots.dot"
      :class="defaultNodeKls"
      :style="{
        borderColor: color,
        borderStyle: 'solid',
        borderWidth: `var(--jd-border-width-1)`,
        backgroundColor: hollow ? '' : color
      }"
    >
      <jd-icon v-if="icon" :class="ns.e('icon')">
        <component :is="icon" />
      </jd-icon>
    </div>
    <div v-if="$slots.dot" :class="ns.e('dot')">
      <slot name="dot" />
    </div>

    <div :class="[ns.e('wrapper'), ns.is('active', active)]">
      <div
        v-if="!hideTimestamp && placement === 'top'"
        :class="[ns.e('timestamp'), ns.is('top')]"
      >
        {{ timestamp }}
      </div>

      <div :class="[ns.e('content'), ns.em('content', size || '')]">
        <slot />
      </div>

      <div
        v-if="!hideTimestamp && placement === 'bottom'"
        :class="[ns.e('timestamp'), ns.is('bottom')]"
      >
        {{ timestamp }}
      </div>
    </div>
  </li>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { JdIcon } from '@jdesign-vue/components/icon'
import { useNamespace } from '@jdesign-vue/hooks'
import { timelineItemProps } from './timeline-item'

defineOptions({
  name: 'JdTimelineItem',
})

const props = defineProps(timelineItemProps)

const ns = useNamespace('timeline-item')
const defaultNodeKls = computed(() => [
  ns.e('node'),
  ns.em('node', props.size || ''),
  ns.em('node', props.type || ''),
  ns.is('hollow', props.hollow),
])
</script>
